export default {
  text: 'Teit tilauksen alle 15 minuuttia sitten! Vahvista, haluatko jatkaa tätä uutta tilausta vai hallinnoida olemassa olevaa tilaustasi.',
  buttons: {
    see_existing_order: 'Näytä olemassa oleva tilaus',
    proceed_new_order: 'Jatka uutta tilausta',
  },
};
